<script setup>
// "Salvar como bloco": pede o nome e grava a linha/elemento em "Meus blocos".
// Abre quando o editor marca `saveBlockTarget` (barra de seleção).
import { ref, inject, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { useAlert } from 'dashboard/composables';

const ed = inject('emailEditor');
const { t } = useI18n();
const dialog = ref(null);
const name = ref('');
const busy = ref(false);

watch(
  () => ed.saveBlockTarget.value,
  id => {
    if (!id) return;
    name.value = '';
    dialog.value?.open();
  }
);
const reset = () => {
  ed.saveBlockTarget.value = null;
};
const confirm = async () => {
  const id = ed.saveBlockTarget.value;
  if (busy.value || !id) return;
  const value = name.value.trim();
  if (!value) {
    useAlert(t('EMAIL_TEMPLATES.EDITOR.SAVED.NAME_REQUIRED'));
    return;
  }
  busy.value = true;
  try {
    await ed.saveAsBlock(id, value);
    useAlert(t('EMAIL_TEMPLATES.EDITOR.SAVED.DONE'));
    dialog.value?.close();
    reset();
  } catch (error) {
    useAlert(
      error?.response?.data?.error || t('EMAIL_TEMPLATES.EDITOR.SAVED.ERROR')
    );
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <Dialog
    ref="dialog"
    :title="t('EMAIL_TEMPLATES.EDITOR.SAVED.DIALOG_TITLE')"
    :confirm-button-label="t('EMAIL_TEMPLATES.EDITOR.SAVED.CONFIRM')"
    @confirm="confirm"
    @close="reset"
  >
    <input
      v-model="name"
      data-test="block-name"
      maxlength="80"
      class="w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
      :placeholder="t('EMAIL_TEMPLATES.EDITOR.SAVED.NAME_PLACEHOLDER')"
      @keydown.enter.prevent="confirm"
    />
  </Dialog>
</template>
